export type InventoryDecision = 'UPDATE_INVENTORY' | 'ESCALATE_TL_THEN_CM' | 'ESCALATE_CM';

export interface InventoryWizardAnswers {
  recent_go_live: boolean;
  tier_1_or_2: boolean;
  campaign_live: boolean;
  request_full_month_or_over_50pct_calendar?: boolean;
  request_over_50pct_month_within_next_3_months?: boolean;
  at_least_30_days_availability_remaining?: boolean;
  has_bnbls?: boolean;
}

export interface InventoryDecisionResult {
  decision: InventoryDecision;
  reason: string;
}

export const INVENTORY_DECISION_LABELS: Record<InventoryDecision, string> = {
  UPDATE_INVENTORY: 'Update Inventory',
  ESCALATE_TL_THEN_CM: 'Escalate to Team Lead, then Campaign Manager',
  ESCALATE_CM: 'Escalate to Campaign Manager',
};

export interface OfferInventoryContext {
  recent_go_live: boolean | null;
  campaign_live: boolean | null;
  tier_1_or_2: boolean | null;
  has_bnbls: boolean | null;
}

export function getDecisionSeverity(decision: InventoryDecision): 'success' | 'warning' | 'error' {
  if (decision === 'UPDATE_INVENTORY') return 'success';
  if (decision === 'ESCALATE_CM') return 'error';
  return 'warning';
}
